module.exports = __webpack_public_path__ + "img/guge.142c59ff.jpg";